// js/core/Level.js
// 關卡狀態工廠與目標／星級評算。

// 由定義產生可玩的關卡狀態（複製可變的收集物／危險物，避免動到原始資料）
export function freshLevel(def) {
  return {
    def,
    destinations: def.destinations.map((d) => ({ ...d, done: false })),
    collectibles: def.collectibles.map((c) => ({ ...c, collected: false })),
    hazards: def.hazards.map((h) => ({ ...h, hit: false })),
  };
}

// 評算結果。星級：★抵達；★★達成一項額外；★★★達成兩項額外（含效率）。
export function evaluate(def, boat, route, elapsed) {
  const goals = def.goals.map((g) => {
    let met = false;
    switch (g.type) {
      case 'deliver': met = !!boat.delivered; break;
      case 'noCollision': met = boat.collisions === 0; break;
      case 'collect': met = boat.collected.includes(g.target); break;
      case 'collectAll': met = boat.collected.length === def.collectibles.length; break;
      case 'efficiency': met = !!boat.delivered && route.length <= (g.maxLength ?? Infinity); break;
      default: met = false;
    }
    return { ...g, met };
  });

  const delivered = !!boat.delivered;
  const extras = goals.filter((g) => g.type !== 'deliver' && g.met).length;
  let stars = 0;
  if (delivered) {
    stars = 1 + (extras >= 1 ? 1 : 0) + (extras >= 2 ? 1 : 0);
    if (stars > 3) stars = 3;
  }

  return { delivered, stars, goals, elapsed, routeLen: route.length, collisions: boat.collisions };
}
